import {apiClient} from './axios';
import {
    CostumeCategory,
    CreateCostumeCategoryRequest,
    PatchCostumeCategoryRequest,
} from '../types/costumeCategory';

export const costumeCategoryApi = {
    getAll: () =>
        apiClient.get<CostumeCategory[]>('/admin/costume-categories'),

    create: (req: CreateCostumeCategoryRequest) =>
        apiClient.post<CostumeCategory>('/admin/costume-categories', req),

    update: (id: number, req: PatchCostumeCategoryRequest) =>
        apiClient.patch<CostumeCategory>(
            `/admin/costume-categories/${id}`,
            req
        ),

    delete: (id: number) =>
        apiClient.deleteNoData(`/admin/costume-categories/${id}`),

    normalize: () =>
        apiClient.postNoData('/admin/costume-categories/normalize'),
};
